<template>
  <div>
    <van-nav-bar
      title="我的收货地址"
      right-text="添加新地址"
      left-arrow
      @click-right="onClickRight"
      @click-left="onClickLeft"
    />
    <div>
      <div class="content" v-for="(item,index) in adrlist" :key="index">
        <div class='carditem carditem2' @click="choseadr(item.address_id)">
          <p>{{item.name}}<span>{{item.phone}}</span></p>
        </div>
        <div class='carditem carditem3' @click="choseadr(item.address_id)">
          <p><span class='moren' v-if="item.status==1">默认</span>{{item.province}}{{item.city}}{{item.district}}{{item.address}}
          </p>
        </div>
        <div class="bianji" @click="goedite(item.address_id)">
          编辑
        </div>
      </div>
    </div>

    <div v-if="adrlist.length==0" class="zwadr">暂无收货地址</div>
  </div>

</template>

<script>
   import Vue from 'vue'
   import {NavBar} from 'vant'

   Vue.use(NavBar)
   export default {
      data() {
         return {
            user_id: localStorage.getItem('user_id'), //用户id
            adrlist: [],
            type: ''
         }
      },
      created() {
         this.type = this.$route.query.type
         this.getaddr()
      },
      onShow() {
         this.getaddr()
      },
      methods: {
         // 选择地址
         choseadr(adrid) {
            if (this.type != 0) {
               if (adrid != '') {
                  console.log(adrid)
                  localStorage.setItem('adrid', adrid)
               }
               this.$router.go(-1)
            }
         },
         // 跳转编辑地址
         goedite(addreid) {
            let that = this
            that.$router.push({
               path: '/addadr',
               query: {
                  addreid: addreid
               }
            })
         },
         // 获取所有的收货地址
         getaddr() {
            this.$http.api.myadrlist({
               user_id: this.user_id
            }).then(result => {
               this.adrlist = result
            })
         },
         // 添加地址按钮
         onClickRight() {
            this.$router.push({
               path: '/addadr'
            })
         },
         onClickLeft() {
            this.$router.go(-1)
         }
      }
   }
</script>

<style>
  .van-nav-bar .van-icon {
    color: #4B4B4C;
  }

  .van-nav-bar__text {
    color: #E85C00;
  }
</style>

<style scoped>
  .zwadr {
    width: 100%;
    display: table;
    font-size: 0.4rem;
    text-align: center;
    margin-top: 0.8rem;
    color: #666;
  }

  .content {
    background-color: #ffffff;
    padding: 0.3rem 0px;
    position: relative;
    margin-top: 0.12rem;
  }

  .content .carditem2 p:first-child {
    color: #333333;
    font-size: 15px;
    margin-left: 20px;

  }

  .content .bianji {
    width: 1rem;
    position: absolute;
    height: 80%;
    right: 10px;
    display: table;
    top: 0px;
    bottom: 0px;
    margin: auto;
    font-size: .34rem;
    color: #333;
  }

  .content .carditem3 p {
    color: #818181;
    font-size: 12px;
    width: 100%;
    display: inline-block;
    padding-left: 8px;
    line-height: 0.55rem;
  }

  .content .carditem3 p {
    color: #818181;
    font-size: 13px;
    width: 100%;
    display: inline-block;
    padding-left: 8px;

  }

  .content .carditem3 .moren {
    width: 33px;
    height: 18px;
    line-height: 18px;
    border: 1px solid rgba(231, 48, 30, 1);
    border-radius: 4px;
    font-size: 12px;
    font-family: SourceHanSansCN-Normal;
    text-align: center;
    color: rgba(231, 48, 30, 1);
    display: inline-block;
    margin-right: 10px;

  }


  .content .order-item {
    width: 100%;
    display: flex;
    position: relative;
    background-color: #fff;
    margin-bottom: 10px;
    padding: 20px 0px 20px;
  }

  .content .carditem3 {
    width: 83%;
    display: table;
    padding: 0px 16px;

  }

  .content .carditem2 {
    width: 73%;
    position: relative;

  }

  .content .carditem {
    display: table;
  }

  .margintop {
    margin-top: 0.1rem;
  }

  .moren {
    position: relative;
    margin-top: 0.16rem;
  }

  .moren .defaultadr {
    position: absolute;
    right: 5%;
    top: 0px;
    bottom: 0px;
    margin: auto;
  }

</style>
